import { IDomainResource } from '../Resource';
import { IBackboneElement } from '../BackboneElement';
import { DaysOfWeek, time } from '../Primitives';
import { IPeriod } from '../Period';
import { IIdentifier } from '../Identifier';
import { IReference } from '../Reference';
import { ICodeableConcept } from '../CodeableConcept';
import { IContactPoint } from '../ContactPoint';
export type PractitionerRoleType = 'PractitionerRole';

export const isPractitionerRole = (
  resource: object | null | undefined,
): resource is IPractitionerRole =>
  !!resource &&
  (resource as IPractitionerRole).resourceType === 'PractitionerRole';

export const createPractitionerRole = (
  practitionerId: string,
  organizationId: string,
  role: { code: string; display: string },
  id?: string,
): IPractitionerRole => {
  const practitionerRole: IPractitionerRole = {
    resourceType: 'PractitionerRole',
    code: [
      {
        coding: [
          {
            code: role.code,
            display: role.display,
            system: 'http://terminology.hl7.org/CodeSystem/practitioner-role',
          },
        ],
      },
    ],
    organization: {
      reference: `Organization/${organizationId}`,
    },
    practitioner: {
      reference: `Practitioner/${practitionerId}`,
    },
    active: true,
  };
  if (id) practitionerRole.id = id;
  return practitionerRole;
};

export interface IPractitionerRoleAvailableTime extends IBackboneElement {
  daysOfWeek?: DaysOfWeek;
  allDay?: boolean;
  availableStartTime?: time;
  availableEndTime?: time;
}

export interface IPractitionerRoleNotAvailable {
  description: string;
  during?: IPeriod;
}

export interface IPractitionerRole
  extends IDomainResource<PractitionerRoleType> {
  identifier?: IIdentifier;
  active?: boolean;
  period?: IPeriod;
  practitioner?: IReference;
  organization?: IReference;
  code?: ICodeableConcept[];
  specialty?: ICodeableConcept;
  location?: IReference;
  healthcareService?: IReference;
  telecom?: IContactPoint;
  availableTime?: [];
  notAvailable?: [];
  availabilityExceptions?: string;
  endpoint?: IReference;
}
